import { makeAutoObservable } from 'mobx'
import {
  IInputStatus,
  IStepsProgress,
  IStepStatus,
  IViewStatus,
} from '../../interface/progress.interface'
import { IProgressSettings } from '../../interface/steps.interface'
import baseProgress from './utils/baseProgress'
import changeInputProgress from './utils/changeInputProgress'
import changeStepProgress from './utils/changeStepProgress'
import isFullStep from './utils/isFullStep'
import checkAllInputsStatusHandler from './modules/checkAllInputStatus/checkAllInputStatusHandler';

class ProgressStore {
  rootStore: any //RootStore
  stepsProgress: IStepsProgress = {}
  currentPercent: number = 5
  progressSettings: IProgressSettings[] = []
  isOptions: string[] = []

  constructor(rootStore: any) {
    this.rootStore = rootStore
    makeAutoObservable(this)
  }

  baseStepsProgress = (
    steps: string[][],
    stepsSettings: any,
    inputs: any,
    values: any,
    currentStepNumber: number,
    isOptions: string[]
  ) => {
    console.log('baseStepsProgress')
    try {
      const { stepsProgress, progressSettings, currentPercent } = baseProgress(
        steps,
        stepsSettings,
        inputs,
        values,
        // this.increaseProgress,
        currentStepNumber,
        isOptions
      )
      this.currentPercent = currentPercent
      console.log(stepsProgress)
      this.stepsProgress = stepsProgress
      this.progressSettings = progressSettings
      this.isOptions = isOptions
    } catch (error) {
      console.log(error)
    }
  }

  increaseProgress = (percent: number | null) => {
    try {
      if (percent) {
        const newPercent = this.currentPercent + percent
        if (newPercent >= 0 && newPercent <= 100) {
          this.currentPercent = newPercent
        }
      }
    } catch (error) {
      console.log(error)
    }
  }

  decreaseProgress = (percent: number | null) => {
    try {
      if (percent) {
        const newPercent = this.currentPercent - percent
        if (newPercent >= 0 && newPercent <= 100) {
          this.currentPercent = newPercent
        }
      }
    } catch (error) {
      console.log(error)
    }
  }

  checkAllInputsStatus = (values: { [name: string]: string }) => {
    try {
      let newStepsProgress = this.stepsProgress
      Object.keys(this.stepsProgress).forEach((stepNumber: any) => {
        let newInputs = this.stepsProgress[stepNumber].inputs
        Object.keys(newInputs).forEach((name: string) => {
          const value = values[name]
          console.log(name, newInputs[name].status, value)
          if (newInputs[name].status === IInputStatus.disabled || newInputs[name].status === IInputStatus.dispensable) {
          } else {
            if (value !== null && value !== '' && value !== undefined) {
              if (newInputs[name].status !== IInputStatus.error && newInputs[name].status !== IInputStatus.apiError)
                newInputs[name].status = IInputStatus.success
            }
            if (value === '') {
              newInputs[name].status = IInputStatus.none
            }
          }
        })
        newStepsProgress[stepNumber].inputs = newInputs
      })
    } catch (error) {
      console.log(error)
    }
  }

  // Функция для проверки всех input для каждого шага и обновления их статуса
  checkAllInputsStatus2 = (values: { [name: string]: string }) => {
    try {
      const newStepsProgress = checkAllInputsStatusHandler(this.stepsProgress, values)

      // Обновляем основной объект stepsProgress
      this.stepsProgress = newStepsProgress;

    } catch (error) {
      console.log(error);
    }
  }


  changeStatus = (name: string, status: IInputStatus, stepNumber: number) => {
    try {
      const step = this.stepsProgress[stepNumber]
      const input = step.inputs[name]
      if (input) {
        const newStep = this.stepsProgress
        changeInputProgress({
          status,
          input,
          increaseProgress: this.increaseProgress,
          decreaseProgress: this.decreaseProgress,
        })
        const isFull = isFullStep(step.inputs)
        const stepStatus = newStep[stepNumber].status
        const stepPercent = newStep[stepNumber].percent
        const newStepStatus = changeStepProgress({
          isFull,
          stepStatus,
          stepPercent,
          increaseProgress: this.increaseProgress,
          decreaseProgress: this.decreaseProgress,
        })
        newStep[stepNumber].status = newStepStatus
        if (status === IInputStatus.none && this.isOptions.indexOf(name) !== -1) {
          newStep[stepNumber].inputs[name].status = IInputStatus.isOptions
        } else {
          newStep[stepNumber].inputs[name].status = status
        }
        this.stepsProgress = newStep
      }
    } catch (error) {
      console.log(error)
    }
  }

  changeAllStepsStatus = (
    currentStepNumber: number,
    prevStepNumber: number
  ) => {
    try {
      console.log('changeAllStepsStatus')
      const newStepsProgress = { ...this.stepsProgress }
      for (let i = 0; i < Object.keys(this.stepsProgress).length; i++) {
        console.log(i, currentStepNumber, newStepsProgress[i].percent)
        if (i === currentStepNumber) {
          newStepsProgress[i].viewStatus = IViewStatus.current
          newStepsProgress[i].status = IStepStatus.current
          console.log('decreaseProgress')
          this.decreaseProgress(newStepsProgress[i].percent)
        }
        if (i > currentStepNumber) {
          newStepsProgress[i].viewStatus = IViewStatus.none
          newStepsProgress[i].status = IStepStatus.none
          if (i < prevStepNumber) {
            console.log('decreaseProgress')
            this.decreaseProgress(newStepsProgress[i].percent)
          }
        }
        if (i < currentStepNumber) {
          //this.decreaseProgress(newStepsProgress[i].percent)
        }
      }
      this.stepsProgress = newStepsProgress
    } catch (error) {
      console.log(error)
    }
  }

  changeStepStatus = (stepNumber: number, status: IStepStatus) => {
    try {
      const newStepsProgress = { ...this.stepsProgress }
      const prevStatus = newStepsProgress[stepNumber].status
      newStepsProgress[stepNumber].status = status
      const percent = newStepsProgress[stepNumber].percent
      if (percent) {
        if (
          prevStatus !== IStepStatus.success &&
          status === IStepStatus.success
        ) {
          this.increaseProgress(percent)
        } else if (status === IStepStatus.change) {
          this.decreaseProgress(percent)
        }
      }
      if (status === IStepStatus.success) {
        newStepsProgress[stepNumber].viewStatus = IViewStatus.check
      } else if (status === IStepStatus.current) {
        newStepsProgress[stepNumber].viewStatus = IViewStatus.current
      }
      this.stepsProgress = newStepsProgress

      console.log('newStepsProgress', { ...newStepsProgress[4].inputs.car_number })
    } catch (error) {
      console.log(error)
    }
  }

  nextStepStatus = (stepNumber: number): [boolean, string | null] => {
    try {
      const { StepsStore } = this.rootStore
      let result = true
      const inputs = this.stepsProgress[stepNumber].inputs
      const newInputs = inputs
      let flag = false
      let firstErrorName: string | null = null

      const invalidInputs: Record<string, string> = {}

      Object.keys(inputs).forEach((name) => {
        console.log(name, inputs[name].status)

        const validStatuses = [
          IInputStatus.success,
          IInputStatus.disabled,
          IInputStatus.notActive,
          IInputStatus.isOptions
        ]
        const validInputStatus = validStatuses.includes(inputs[name].status)
        // const isInvalidInputStatus = inputs[name].status !== IInputStatus.success &&
        //   inputs[name].status !== IInputStatus.disabled &&
        //   inputs[name].status !== IInputStatus.notActive &&
        //   inputs[name].status !== IInputStatus.isOptions

        if (!validInputStatus) {
          if (!flag) {
            firstErrorName = name
          }
          flag = true
          if (StepsStore.values[name] === '' || StepsStore.values[name] === undefined) {
            newInputs[name].status = IInputStatus.error
          }
          result = false
          invalidInputs[name] = name
        } else if (
          inputs[name].status !== IInputStatus.apiError &&
          inputs[name].status !== IInputStatus.error
        ) {
          delete invalidInputs[name]
        }
        console.log(inputs[name].status)
      })
      if (flag) {
        const newStepsProgress = { ...this.stepsProgress }
        newStepsProgress[stepNumber].inputs = newInputs
        console.log('newInputs', {...newInputs})
        this.stepsProgress = newStepsProgress
      }

      StepsStore.invalidInputs = invalidInputs
      return [result, firstErrorName]
    } catch (error) {
      console.log(error)
      return [false, null]
    }
  }
}

export default ProgressStore
